import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import {useMediaQuery} from "react-responsive";
import {BaseModal} from "../../../components/BaseModal";
import {mediaQueryForMobile} from "../../HomePage/HomePage";
import {useThemeStore} from "../../../stores/themeStore";
import {useListingDetail} from "./useListingDetail";
import {ListingDetail} from "./ListingDetail";
import "./ListingDetail.scss";

export const ListingDetailModal = ({isOpen, setIsOpen, listingId, onSelectListing}) => {
    const isTabletOrMobile = useMediaQuery({query: mediaQueryForMobile})
    const theme = useThemeStore((state) => state.theme)
    const isDark = theme === 'dark'
    const {listing, loading, error} = useListingDetail(listingId)

    // VehicleCard forwards its ListingsSelectionContext callback as a prop (this
    // modal renders outside that provider). Re-package it for ListingDetail so
    // "Select Vehicle" reports back to the deal / calculator exactly like the
    // card's Select does. Absent — the standalone /listings case — we pass null
    // and the shared hook keeps its new-tab behavior.
    //
    // Closing THIS modal has to happen before invoking the callback: the opener
    // (ListingsPageModal) closes itself inside it, and modalsStore.closeModal
    // splices by index, so a close-after would use a stale, shifted index and
    // silently leave Listing Details floating over the DealPage.
    const selection = onSelectListing
        ? {
            onSelectListing: (data) => {
                setIsOpen(null)
                onSelectListing(data)
            },
        }
        : null

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: isDark ? '#161c2a' : '#fff',
        borderRadius: '12px',
        width: isTabletOrMobile ? '100vw' : '72vw',
        height: isTabletOrMobile ? '92vh' : '88vh',
        outline: 'none',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    }

    return (
        <BaseModal isOpen={isOpen} setIsOpen={setIsOpen} style={style}>
            <div className="ld-modal-inner" data-theme={theme}>
                <div className="ld-modal-header">
                    <span>Listing Details</span>
                    <button className="ld-close-btn" onClick={() => setIsOpen(null)}>
                        <CloseIcon/>
                    </button>
                </div>
                <div className="ld-modal-body">
                    {loading && <div className="ld-center"><CircularProgress/></div>}
                    {!loading && error && <div className="ld-center ld-error">Couldn’t load this listing.</div>}
                    {!loading && !error && listing && <ListingDetail listing={listing} selection={selection}/>}
                    {!loading && !error && !listing && <div className="ld-center">Listing not found.</div>}
                </div>
            </div>
        </BaseModal>
    )
}
